import { createFileRoute } from "@tanstack/react-router";
import Messages from "@/pages/Messages";
import { PrivateRoute } from "@/components/shared/PrivateRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/messages/")({
  head: () => routeHead("/uk/messages/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateRoute><Messages /></PrivateRoute>
  );
}
